(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cela-marquee"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cela-marquee')) {
    class CelaMarquee extends HTMLElement {
      static get observedAttributes() {
        return ['data-duration', 'data-animated'];
      }

      connectedCallback() {
        this.initFrame = requestAnimationFrame(() => this.initialize());
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        this.stopFrame();
        this.events?.abort();
        this.resizeObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        this.pointer = null;
        this.initialized = false;
        this.removeAttribute('data-ready');
        this.removeAttribute('data-dragging');
        if (this.track) this.track.style.transform = '';
      }

      attributeChangedCallback() {
        if (this.initialized) this.startFrame();
      }

      initialize() {
        if (!this.isConnected || this.initialized) return;
        this.track = this.querySelector('[data-marquee-track]');
        this.group = this.track?.querySelector('[data-marquee-group]:not([data-marquee-duplicate])');
        this.duplicate = this.track?.querySelector('[data-marquee-duplicate]');
        if (!this.track || !this.group) return;

        this.initialized = true;
        this.events = new AbortController();
        const signal = this.events.signal;
        this.offset = this.offset || this.scrollLeft || 0;
        this.period = this.period || 0;
        this.viewport = 0;
        this.looping = false;
        this.hovered = window.matchMedia('(hover: hover) and (pointer: fine)').matches && this.matches(':hover');
        this.keyboardMode = Boolean(document.activeElement?.matches(':focus-visible'));
        this.pointerFocusUntil = 0;
        this.focused = this.contains(document.activeElement)
          && (this.keyboardMode || this.isEditable(document.activeElement));
        this.visible = true;
        this.selectedBlock = null;
        this.resumeAfter = 0;
        this.suppressClickUntil = 0;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.motion.addEventListener('change', () => this.startFrame(), { signal });

        this.addEventListener('pointerdown', (event) => this.onPointerDown(event), { signal });
        this.addEventListener('pointermove', (event) => this.onPointerMove(event), { signal, passive: false });
        this.addEventListener('pointerup', (event) => this.finishPointer(event), { signal });
        this.addEventListener('pointercancel', (event) => this.finishPointer(event), { signal });
        this.addEventListener('lostpointercapture', (event) => {
          // A touched child loses its implicit capture when dragging transfers capture here.
          // That bubbling event must not end the carousel's active drag.
          if (event.target === this) this.finishPointer(event);
        }, { signal });
        this.addEventListener('pointerenter', (event) => {
          if (event.pointerType === 'mouse') this.hovered = true;
        }, { signal });
        this.addEventListener('pointerleave', (event) => {
          if (event.pointerType !== 'mouse') return;
          this.hovered = false;
          if (this.pointer && !this.pointer.dragging) this.finishPointer(event);
          this.resumeAutoplay();
        }, { signal });
        this.addEventListener('focusin', (event) => {
          const keyboardFocus = this.keyboardMode
            || (performance.now() >= this.pointerFocusUntil && event.target.matches(':focus-visible'));
          this.focused = keyboardFocus || this.isEditable(event.target);
          if (keyboardFocus && event.target !== this) this.revealElement(event.target, false);
        }, { signal });
        this.addEventListener('focusout', (event) => {
          if (event.relatedTarget && this.contains(event.relatedTarget)) return;
          this.focused = false;
          this.resumeAutoplay();
        }, { signal });
        this.addEventListener('keydown', (event) => this.onKeyDown(event), { signal });
        this.addEventListener('wheel', (event) => this.onWheel(event), { signal, passive: false });
        this.addEventListener('click', (event) => {
          if (performance.now() >= this.suppressClickUntil || this.isFormControl(event.target)) return;
          this.suppressClickUntil = 0;
          event.preventDefault();
          event.stopPropagation();
        }, { signal, capture: true });
        this.addEventListener('dragstart', (event) => {
          if (event.target.closest('img, a')) event.preventDefault();
        }, { signal });
        this.addEventListener('scroll', () => {
          if (this.hasAttribute('data-ready') && this.scrollLeft) this.scrollLeft = 0;
        }, { signal, passive: true });

        document.addEventListener('pointerdown', (event) => this.setPointerModality(event), { signal, capture: true });
        document.addEventListener('keydown', (event) => {
          if (['Alt', 'Control', 'Meta', 'Shift'].includes(event.key)) return;
          this.keyboardMode = true;
          if (this.contains(document.activeElement)) {
            this.focused = true;
            if (document.activeElement !== this) this.revealElement(document.activeElement, false);
          }
        }, { signal, capture: true });
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.stopFrame();
          else this.startFrame();
        }, { signal });
        document.addEventListener('shopify:block:select', (event) => {
          const block = Array.from(this.group.querySelectorAll('[data-block-id]')).find(
            (element) => element.dataset.blockId === String(event.detail?.blockId)
          );
          if (!block) return;
          this.selectedBlock = block;
          this.revealElement(block, true);
        }, { signal });
        document.addEventListener('shopify:block:deselect', (event) => {
          if (this.selectedBlock?.dataset.blockId !== String(event.detail?.blockId)) return;
          this.selectedBlock = null;
          this.resumeAutoplay();
        }, { signal });

        this.resizeObserver = new ResizeObserver(() => this.measure());
        this.resizeObserver.observe(this);
        this.resizeObserver.observe(this.group);
        this.intersectionObserver = new IntersectionObserver((entries) => {
          this.visible = entries[0].isIntersecting;
          if (this.visible) this.startFrame();
          else this.stopFrame();
        }, { threshold: 0 });
        this.intersectionObserver.observe(this);
        this.measure();
        this.startFrame();
      }

      isFormControl(target) {
        return Boolean(target.closest('button, input, select, textarea, label, form, product-form, a.button, [role="button"], [contenteditable="true"]'));
      }

      isEditable(target) {
        return Boolean(target?.closest('input:not([type="hidden"]), select, textarea, [contenteditable="true"]'));
      }

      setPointerModality(event) {
        this.keyboardMode = false;
        this.pointerFocusUntil = performance.now() + 1200;
        this.focused = this.contains(event.target) && this.isEditable(event.target);
      }

      measure() {
        if (!this.initialized) return;
        const styles = getComputedStyle(this);
        this.paddingLeft = parseFloat(styles.paddingLeft) || 0;
        const viewport = this.clientWidth - this.paddingLeft - (parseFloat(styles.paddingRight) || 0);
        const period = this.group.getBoundingClientRect().width;
        if (viewport <= 0 || period <= 0) return;

        const oldPeriod = this.period;
        const changed = Math.abs(period - oldPeriod) > 0.5;
        this.viewport = viewport;
        this.period = period;
        this.maximum = Math.max(0, period - viewport);
        this.looping = Boolean(this.duplicate && this.maximum > 1);
        this.setAttribute('data-looping', String(this.looping));
        this.setAttribute('data-overflow', String(this.maximum > 1));
        this.setAttribute('data-ready', '');
        this.scrollLeft = 0;
        const nextOffset = changed && oldPeriod > 0 ? this.offset * period / oldPeriod : this.offset;
        this.setOffset(nextOffset);
        if (this.pointer) {
          this.pointer.startOffset = this.offset;
          this.pointer.startX = this.pointer.lastX;
        }
        if (this.selectedBlock) this.revealElement(this.selectedBlock, true);
        else if (this.focused && document.activeElement !== this && this.contains(document.activeElement)) {
          this.revealElement(document.activeElement, false);
        }
      }

      setOffset(value) {
        if (!Number.isFinite(value) || !this.period) return;
        this.offset = this.looping
          ? ((value % this.period) + this.period) % this.period
          : Math.max(0, Math.min(this.maximum, value));
        this.track.style.transform = `translate3d(${-this.offset}px, 0, 0)`;
      }

      resumeAutoplay() {
        this.resumeAfter = 0;
        this.startFrame();
      }

      startFrame() {
        if (!this.initialized || this.frame || !this.visible || document.hidden) return;
        this.lastTime = null;
        this.frame = requestAnimationFrame((now) => this.tick(now));
      }

      stopFrame() {
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = null;
        this.lastTime = null;
      }

      tick(now) {
        this.frame = null;
        if (!this.initialized || !this.isConnected || !this.visible || document.hidden) return;
        const elapsed = this.lastTime === null ? 0 : Math.min(now - this.lastTime, 64);
        this.lastTime = now;
        const canAnimate = this.dataset.animated === 'true' && this.looping && !this.motion.matches
          && !this.hovered && !this.focused && !this.pointer && !this.selectedBlock && now >= this.resumeAfter;
        if (canAnimate && elapsed > 0) {
          const duration = Math.max(5, Number(this.dataset.duration) || 75);
          this.setOffset(this.offset + elapsed * this.period / (duration * 1000));
        }
        this.frame = requestAnimationFrame((time) => this.tick(time));
      }

      onPointerDown(event) {
        this.setPointerModality(event);
        this.resumeAutoplay();
        if (event.button !== 0 || event.isPrimary === false || this.pointer || this.maximum <= 1 || this.isFormControl(event.target)) return;
        this.pointer = {
          id: event.pointerId,
          startX: event.clientX,
          lastX: event.clientX,
          startY: event.clientY,
          startOffset: this.offset,
          dragging: false
        };
      }

      onPointerMove(event) {
        const pointer = this.pointer;
        if (!pointer || pointer.id !== event.pointerId) return;
        pointer.lastX = event.clientX;
        const deltaX = event.clientX - pointer.startX;
        const deltaY = event.clientY - pointer.startY;
        if (!pointer.dragging) {
          if (Math.abs(deltaY) > 8 && Math.abs(deltaY) > Math.abs(deltaX)) {
            this.pointer = null;
            this.resumeAutoplay();
            return;
          }
          if (Math.abs(deltaX) < 7 || Math.abs(deltaX) < Math.abs(deltaY) * 1.15) return;
          pointer.dragging = true;
          this.setAttribute('data-dragging', '');
          this.setPointerCapture(event.pointerId);
        }
        if (event.cancelable) event.preventDefault();
        this.setOffset(pointer.startOffset - deltaX);
      }

      finishPointer(event) {
        const pointer = this.pointer;
        if (!pointer || pointer.id !== event.pointerId) return;
        this.pointer = null;
        this.removeAttribute('data-dragging');
        if (pointer.dragging) this.suppressClickUntil = performance.now() + 450;
        if (this.hasPointerCapture(pointer.id)) this.releasePointerCapture(pointer.id);
        this.resumeAutoplay();
      }

      onWheel(event) {
        if (this.maximum <= 1) return;
        const horizontal = Math.abs(event.deltaX) > Math.abs(event.deltaY);
        if (!horizontal && !event.shiftKey) return;
        let delta = horizontal ? event.deltaX : event.deltaY;
        if (event.deltaMode === 1) delta *= 16;
        if (event.deltaMode === 2) delta *= this.viewport;
        if (!delta) return;
        const next = this.looping ? this.offset + delta : Math.max(0, Math.min(this.maximum, this.offset + delta));
        if (next === this.offset) return;
        event.preventDefault();
        this.setOffset(next);
        this.resumeAutoplay();
      }

      onKeyDown(event) {
        if (event.target !== this || this.maximum <= 1) return;
        const step = Math.max(80, Math.min(this.viewport * 0.7, 360));
        let next;
        if (event.key === 'ArrowRight') next = this.offset + step;
        else if (event.key === 'ArrowLeft') next = this.offset - step;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = this.maximum;
        else return;
        event.preventDefault();
        this.setOffset(next);
        this.resumeAutoplay();
      }

      revealElement(element, center) {
        if (!this.period) return;
        const group = element.closest('[data-marquee-group]');
        if (!group) return;
        let card = element;
        while (card.parentElement && card.parentElement !== group) card = card.parentElement;
        const bounds = card.getBoundingClientRect();
        const viewportLeft = this.getBoundingClientRect().left + this.paddingLeft;
        if (!center && bounds.left >= viewportLeft && bounds.right <= viewportLeft + this.viewport) return;
        const localLeft = bounds.left - group.getBoundingClientRect().left;
        const target = localLeft - Math.max(0, (this.viewport - bounds.width) / 2);
        this.setOffset(Math.max(0, Math.min(this.maximum, target)));
      }
    }

    customElements.define('cela-marquee', CelaMarquee);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-description-preview"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-description-preview')) {
    customElements.define('product-description-preview', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        const button = this.querySelector('[data-description-toggle]');
        const preview = this.querySelector('[data-description-preview]');
        const full = this.querySelector('[data-description-full]');
        if (!button || !preview || !full) return;
        this.controller = new AbortController();
        const setExpanded = (expanded) => {
          full.hidden = !expanded;
          preview.hidden = expanded;
          button.setAttribute('aria-expanded', String(expanded));
          button.textContent = expanded ? button.dataset.less : button.dataset.more;
        };
        setExpanded(false);
        button.hidden = false;
        button.addEventListener('click', () => {
          setExpanded(button.getAttribute('aria-expanded') !== 'true');
        }, { signal: this.controller.signal });
      }

      disconnectedCallback() {
        this.controller?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
